module.exports = __webpack_public_path__ + "static/media/beans-curry.ddbe97c2.jpg";